(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/game/assets/javascripts/views/package-rows.js') >= 0) return;  svs.modules.push('/components/numbergames/game/assets/javascripts/views/package-rows.js');

'use strict';

svs.numbergames.game.views.PackageRows = Marionette.View.extend({
  ballRows: undefined,
  ballRowSize: svs.core.detect.breakpoint.greaterThan('xs') ? 300 : 200,
  ui: {
    rows: '.js-package-rows-balls'
  },
  modelEvents: {
    'change:selectedPackage change:rowPriceMulti': 'render'
  },
  behaviors: [{
    behaviorClass: svs.numbergames.core.behaviors.BindViewRadio,
    channel: svs.numbergames.game.huxfluxRadio
  }],
  className() {
    const brandingSuffix = svs.numbergames.productMapping.getBrandingClass(this.model.get('productId'));
    return "package-rows package-rows-".concat(brandingSuffix);
  },
  template: data => svs.numbergames.game.templates.package_rows(data),
  templateContext() {
    const numberOfBoards = this.model.get('boards').getNumberOfValidBoards();
    let packageTitle = "Mina ".concat(numberOfBoards, " rader");
    if (svs.numbergames.productMapping.isLotto(this.model.get('productId'))) {
      const jokerPrice = this.model.get('jokerPrice');
      packageTitle += ", Lotto 1 & 2 + Joker (".concat(jokerPrice, " kr)");
    }
    return {
      packageTitle
    };
  },
  initialize() {
    const boards = this.model.get('boards');
    this.listenTo(boards, 'huxfluxedAll', this.onHuxfluxRows);
  },
  onRender() {
    this.addBallRows();
    if (this.model.get('boards').isNewBoards) {
      this.onHuxfluxRows();
      this.model.get('boards').isNewBoards = false;
    }
  },
  addBallRows() {
    const boards = this.model.get('boards').getValidBoards();
    const productId = this.model.get('productId');
    const _svs$numbergames$prod = svs.numbergames.productMapping,
      getProductName = _svs$numbergames$prod.getProductName,
      isKeno = _svs$numbergames$prod.isKeno;
    const productName = getProductName(productId);
    const ballrow = svs.tur.ball.row[productName] || svs.tur.ball.row.Default;
    const rows = [];
    boards.forEach(board => {
      const isNewBoards = this.model.get('boards').isNewBoards;
      const options = {
        numbers: isNewBoards ? new Array(board.get('numbers').length).fill() : board.get('numbers').toArray(),
        extraNumbers: board.has('numbersExtra') && (isNewBoards ? new Array(board.get('numbersExtra').length).fill() : board.get('numbersExtra').toArray()),
        size: this.getOption('ballRowSize'),
        kungKeno: board.get('hasKungKeno')
      };
      if (isKeno(productId)) {
        const getLevelWinPlanTopWin = svs.numbergames.rules.utils.keno_winplan.getLevelWinPlanTopWin;
        const rowPrice = this.model.get('rowPrice') * this.model.get('rowPriceMulti');
        const level = board.get('level');
        const hasKungKeno = board.get('hasKungKeno');
        const maxWin = getLevelWinPlanTopWin({
          level,
          rowPrice,
          hasKungKeno
        });
        options.winPlan = new svs.tur.ball.row.extensions.WinPlan({
          title: "Keno ".concat(board.get('level')),
          description: "- Toppvinst ".concat(svs.utils.format.Currency(maxWin), " kr")
        });
      }
      rows.push(new ballrow(options));
    });
    this.ballRows = new svs.tur.ball.rows.Default({
      rows,
      useGrid: true
    });
    this.ballRows.on(svs.tur.ball.constants.HUXFLUX_STARTED, () => this.radio.trigger('package:huxflux:started'));
    this.ballRows.on(svs.tur.ball.constants.HUXFLUX_COMPLETED, () => this.radio.trigger('package:huxflux:ended'));
    this.getUI('rows').empty();
    this.getUI('rows').append(this.ballRows.render());
  },
  onHuxfluxRows() {
    const boards = this.model.get('boards');
    this.ballRows.rows.forEach((row, i) => {
      const _boards$at$getNumberL = boards.at(i).getNumberListArrays(),
        numbers = _boards$at$getNumberL.numbers,
        numbersExtra = _boards$at$getNumberL.numbersExtra;
      const numbersConcat = numbersExtra ? numbers.concat(numbersExtra) : numbers;
      row.prepare(numbersConcat);
    });
    this.ballRows.huxflux();
    if (this.model.get('hasJoker')) this.model.set({
      jokerRow: svs.numbergames.rules.joker.getHuxfluxedRow()
    });
  }
});

 })(window);